import { ref, readonly } from 'vue'
import { Network } from '@capacitor/network'

// Module-scoped singleton so every consumer shares one plugin listener.
// Never call Network.removeAllListeners() elsewhere — it would detach this.
const isOnline = ref(true)
const connectionType = ref('unknown')
let initialized = false

const applyStatus = (status) => {
  isOnline.value = status.connected
  connectionType.value = status.connectionType
}

const init = async () => {
  if (initialized) return
  initialized = true

  Network.addListener('networkStatusChange', applyStatus)

  try {
    applyStatus(await Network.getStatus())
  } catch (error) {
    console.error('[useNetworkStatus] Failed to read network status:', error)
  }
}

export function useNetworkStatus() {
  init()

  return {
    isOnline: readonly(isOnline),
    connectionType: readonly(connectionType)
  }
}
